import { SparklesIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { api } from "../../shared/api";
import ContentEditable from "react-contenteditable";

const PromptMenu = (props) => {

    const componentRef = useRef(null);
    const ref = useRef(null);

    const [prompt, setPrompt] = useState();
    const [loading, setLoading] = useState(false);

    const [abortController, setAbortController] = useState(null);

    const fetchCompletion = (prompt) => {

        props.setLoadingInitialCompletion(true);

        const controllerInstance = new AbortController();
        setAbortController(controllerInstance);



        fetch(api + "/ai/prompt", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/event-stream"
            },
            body: JSON.stringify({
                prompt: prompt,
                document: props.parentHtml
            }),
            signal: controllerInstance.signal
        })
            .then(async response => {
                const completion = response.body;
                console.log("STREAMING")
                // eslint-disable-next-line no-undef
                const reader = completion.getReader();
                let result = { content: "" };


                while (true) {
                    const { value, done } = await reader.read();




                    if (new TextDecoder().decode(value).includes("{")) {


                        const regex = /<chunk>\s*({[^]*?})\s*<\/chunk>/g;

                        let match;
                        const matches = [];

                        while (match = regex.exec(new TextDecoder().decode(value))) {
                            const jsonPart = match[1];
                            matches.push(JSON.parse(jsonPart));
                        }


                        if (matches) {
                            matches.map(match => {
                                // Extract the JSON part from each match
                                const jsonPart = match


                                if (jsonPart.content) {
                                    result.content = result.content + jsonPart.content;
                                    //  console.log("Content:", result.content);
                                    // Create a new instance of chatHistory with updated data

                                    props.setParentHtml(result.content)

                                }
                            });
                        }

                    }





                    // Here, you can parse the received data and update the state as needed
                    if (done) {
                        console.log("DONE STREAMING")
                        setLoading(false)
                        props.setPromptMenuOpen(false)
                        break;
                    }
                }


            }).catch(err => {
                console.log(err)
                setLoading(false)
            })

    }

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, [abortController]);

    const stopStreaming = () => {
        if (abortController) {
            console.log("Aborting")
            abortController.abort();
            setAbortController(null);
        }
    };

    useEffect(() => {
        function handleClick(event) {
            if (componentRef.current && !componentRef.current.contains(event.target)) {
                setLoading(false);
                stopStreaming();
                props.setPromptMenuOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [abortController])

    function handleKeyDown(e) {
        e.stopPropagation();
        if (e.key == "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (prompt && prompt.length > 0) {
                setLoading(true);
                fetchCompletion(prompt);
            }
        }
        else if (e.key == "Escape") {
            e.preventDefault();
            setLoading(false);
            stopStreaming();
            props.setPromptMenuOpen(false)
        }
    }

    
        useEffect(() => {
           
            document.addEventListener('keydown', handleKeyDown);
    
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }, [prompt, abortController])

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false);
            props.setLoadingInitialCompletion(false);

        }, 1000)

        return () => {
            clearTimeout(timeout);
        }
    }, [props.parentHtml])


    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, [])


    return (
        <div ref={componentRef} className={`w-full absolute bottom-[-64px] z-[100] left-0 down-and-fade-in `}>
            <div className="w-full py-2 px-4 rounded-xl shadow-xl bg-white border-gray-100 border flex items-center gap-0.5 relative">
                {loading ?
                    <div role="status" className="shrink-0">
                        <svg aria-hidden="true" class="w-5 h-5 text-gray-300 animate-spin fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>
                    :
                    <SparklesIcon className="h-5 w-5 text-violet-500 shrink-0" />}
                <div className="relative px-[12px] py-[8px] w-full">
                    <ContentEditable html={prompt ? prompt : ""} onChange={(e) => { setPrompt(e.target.value); console.log(prompt) }} className="max-h-[72px] overflow-y-auto border-none outline-none focus:ring-0 focus:outline-none" innerRef={ref} placeholder="What do you want to write?" />
                    {(!prompt || prompt.length == 0) &&
                        (
                            <p
                                className={'opacity-20 h-full flex flex-col justify-center'}
                                style={{ position: 'absolute', top: 0, }}
                            >
                                What do you want to write?
                            </p>
                        )}
                </div>

            </div>
        </div>
    )
}

export default PromptMenu;